import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { useEffect } from 'react';
import { animated } from 'react-spring';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { PaidFeatureBlock, SharingWidnowContext } from 'reactApp/components/SharingWindow/blocks/PaidFeaturesBlock/PaidFeatureBlock';
import type { EFrom } from 'reactApp/components/SharingWindow/Sharing.types';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import { sendDwh } from 'reactApp/utils/ga';

import { SharingOnboardingHeader } from './components/header/SharingOnboardingHeader';
import { useOpenTransition } from './hooks/useOpenTransition';
import styles from './SharingOnboarding.css';

interface SharingOnboardingProps {
    isTabDesign?: boolean;
    itemStorage?: EStorageType;
    isPhone?: boolean;
    from: EFrom;
    id: string;
}

export function SharingOnboarding(props: SharingOnboardingProps) {
    const { isOpen, ref, style, toggleExpand } = useOpenTransition({ openDefault: true });

    useEffect(() => {
        const eventName = isOpen
            ? AnalyticEventNames.SHARING_ADVANCED_SETTINGS_PUBLIC_SHOW
            : AnalyticEventNames.SHARING_ADVANCED_SETTINGS_PUBLIC_HIDDEN;
        emitAnalyticEvent(eventName);
        sendDwh({
            eventCategory: 'advanced-settings-public',
            action: isOpen ? 'show' : 'hidden',
            dwhData: {
                paid_user: false,
            },
        });
    }, [isOpen]);

    return (
        <div data-qa-section="sharing-onboarding">
            <SharingOnboardingHeader opened={isOpen} toggleOpened={toggleExpand} />
            <animated.div style={style} className={styles.animated}>
                <div
                    data-qa-id={'sharing-onboarding-body'}
                    ref={ref}
                    className={classNames(styles.root, { [styles.tabDesign]: props.isTabDesign })}
                >
                    <Spacing size={8} />
                    <PaidFeatureBlock
                        context={SharingWidnowContext.ONBOARDING}
                        from={props.from}
                        id={props.id}
                        isPhone={props.isPhone}
                        itemStorage={props.itemStorage}
                        isTabDesing={props.isTabDesign}
                    />
                </div>
            </animated.div>
        </div>
    );
}
